import { Component, OnInit, ViewChildren, QueryList, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, Validators, FormGroup, NgForm , FormArray} from '@angular/forms';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPromptComponent } from '../../../../_helpers/Modals/prompt/modal.prompt';
import { Router, ActivatedRoute } from '@angular/router';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { APIEntityService } from '../../_services/entity/API-entity';



const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
console.log("formatTime -- : ", formatTime);

export interface DialogData {
  setValue: string,
  setRole: string
}
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-petmbinding-pelist',
  templateUrl: './petmbinding-pelist.component.html',
  styleUrls: ['./petmbinding-pelist.component.css']

})

export class PETMBindingPEListComponent implements OnInit {

  maxDate: Date = new Date();
  mindate = new Date(now.getFullYear(), 0, 1);
  maxdate = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  dataSource: MatTableDataSource<any>;



  PETMBindingForm: FormGroup;
  actionForm: FormGroup;
  public modalRef: BsModalRef;
  form1: any = {};
  data: any = {};
  filterData: any;
  pageNo: number = 1;
  pageSize: number = 5;
  length: number = 5;
  Param: any;
  fetchedData: any;
  noRecord: any;
  afterApply: boolean = false;
  // commentReq: boolean = false;

  Status: any;
  public queryData: any = { sts: "" };
  searchError: boolean = false;
  showStatusDropdown: boolean = false;
  entityName: any;
  entityId: any;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('t1Sort') t1Sort: MatSort;

  dataSubject = new BehaviorSubject<any[]>([]);


  displayedColumns: string[] = ['URN', 'ChainID', 'Chainparticipants', 'ChainStatus', 'createdAt', 'updatedAt', 'Action'];


  constructor(
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private es: APIEntityService,
    private _route: ActivatedRoute,
    public dialog: MatDialog,
    private $: $BroadcastManagerService,
    private modalService: BsModalService,
    private router: Router) {
    this._route.params.subscribe((params) => {

      this.entityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
      this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    });
  }


  ngOnInit() {

    this.PETMBindingForm = this.fb.group({
      pe_ID: ['',],
      pe_name: ['',]
    });

    this.actionForm = this.fb.group({
      comments: this.fb.array([])
    });


    this.maxDate.setDate(new Date().getDate());

    this.PETMBindingForm.controls['pe_ID'].setValue(this.entityId);
    this.PETMBindingForm.controls['pe_name'].setValue(this.entityName);

    this.data = {
      "EntityID": this.entityId
    }

    this.fetchpetmbindinglist(this.data)

  }

  get f() { return this.PETMBindingForm.controls; }

  get fm() { return this.actionForm.controls }


  onChangeDataSource(value) {
    for (let i = 0; i < value.message.length; i++) {
      (<FormArray>this.actionForm.controls['comments']).push(this.fb.control('', []))
        // this.actionForm.controls.comments.get(i.toString()).setValue("");
    }
    this.dataSource = new MatTableDataSource(value.message);
    console.log("------------------values" + this.dataSource);
    this.dataSource.paginator = this.paginator.toArray()[0];
    // console.log("values" + value);
    this.dataSource.sort = this.t1Sort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));


  }




  searchRequired: boolean = false;
  errorSerch() {
    if (this.form1.searchBy && !this.form1.search) {
      this.searchRequired = true;
    } else {
      this.searchRequired = false;

    }
  }

  onSubmit() {

    console.log("------------this.data---", this.data)
    this.fetchpetmbindinglist(this.data)

  }
  onSubmitFilter1(filterForm, form) {

    console.log("filterForm", filterForm);
    console.log("hi !!!");
    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;
    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    var param = filterForm.searchBy

    //console.log("-------param----------", param)
    // var param = filterForm.search
    if (typeof param === 'undefined' || param == null)
      param = "";

    var filterType
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;

    if (filterForm.searchBy1)
      param = filterForm.searchBy1;
    //console.log("-------param-----srch1-----", param)

    if (filterForm.search)
      param = filterForm.search;
    //console.log("-------param----srch------", param)


    var difference_in_Time = new Date(ldate).getTime() - new Date(fdate).getTime()
    var difference_in_Days = difference_in_Time / (1000 * 3600 * 24)
    //console.log("difference_in_Timedifference_in_Time in days", difference_in_Time)



    if (fdate != "" && ldate == "") {
      ldate = cdate
    }

    this.data = {

      "Start_Date": fdate,
      "End_Date": ldate,
      "filterType": filterType,
      "param": param,
      // "EntityID": this.entityId

    }

    if (fdate == "" && ldate == "" && param == "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select any option'
      });
    }
    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select Start date'
      });
    }
    else if (fdate > ldate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'From Date cannot be after To Date'
      });
    }



    // else {

    this.fetchpetmbindinglist(this.data)
    // }
  }
  onSubmitFilter(filterForm, form) {

    //console.log("filterForm", filterForm);
    //console.log("hi !!!");
    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;
    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    var param = filterForm.searchBy
    
    //console.log("-------param----------", param)
    // var param = filterForm.search
    if (typeof param === 'undefined' || param == null)
      param = "";

    var filterType
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;

    if (filterForm.searchBy1)
      param = filterForm.searchBy1;
    //console.log("-------param-----srch1-----", param)

    if (filterForm.search)
      param = filterForm.search;
    //console.log("-------param----srch------", param)

    var difference_in_Time = new Date(ldate).getTime() - new Date(fdate).getTime()
    var difference_in_Days = difference_in_Time / (1000 * 3600 * 24)
    //console.log("difference_in_Timedifference_in_Time in days", difference_in_Time)

    if (fdate != "" && ldate == "") {
      ldate = cdate
    }

    this.data = {

      "Start_Date": fdate,
      "End_Date": ldate,
      "filterType": filterType,
      "param": param,
      "EntityID": this.entityId

    }

    if (fdate == "" && ldate == "" && param == "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select any option'
      });
    }
    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select Start date'
      });
    }
    else if (fdate > ldate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'From Date cannot be after To Date'
      });
    }
    else {

      this.fetchpetmbindinglist(this.data)
    }
  }
  fetchpetmbindinglist(data) {

    this.es.petmbindinglist(data)
      .subscribe(r => {
        if (r.status == "success") {
          console.log(r)
          this.fetchedData = JSON.stringify(r);
          console.log("----------fetcch---------------------", this.fetchedData)
          this.dataSource = r;
          // console.log("---------datasource----------------", this.dataSource)
          this.onChangeDataSource(r);
        }

      })
  }
  
  
  onKey(event: any, urn: any, j: any) {
    console.log("j in onkey----------------",j)
      this.actionForm.controls.comments.get(j.toString()).setValidators([Validators.required])
      this.actionForm.controls.comments.get(j.toString()).updateValueAndValidity()
  }

  ApproveFn(urn,j) {
    // this.commentReq = (this.actionForm.get('comments').value == "") ? true : false;
    if(this.actionForm.controls.comments.get(j.toString()).value == ""){
      this.actionForm.controls.comments.get(j.toString()).setValidators([Validators.required])
      this.actionForm.controls.comments.get(j.toString()).updateValueAndValidity()
    } else {
      this.actionForm.controls.comments.get(j.toString()).clearValidators()
      this.actionForm.controls.comments.get(j.toString()).updateValueAndValidity()
    }
    if (this.actionForm.valid) {
      this.data = {
        "urn": urn,
        "EntityID": this.entityId,
        "Remarks": this.actionForm.controls.comments.get(j.toString()).value,
        "action": 'AP'
      }
      this.es.peactionforbinding(this.data)
        .subscribe(r => {
          if (r.status == "success") {
            this.$modal.successModal({
              title: 'PE TM Binding Action',
              msg: r.message
            });
            // this.router.navigateByUrl('/petmbinding-pelist');
            this.data = {
              "EntityID": this.entityId
            }
            this.fetchpetmbindinglist(this.data)

          }
          else {
            this.$modal.errorModal({
              title: 'PE TM Binding Action',
              msg: r.message
            });
          }
        })
    }
  }

  RejectFn(urn,j) {
    console.log("j in reject----------------",j,this.actionForm)
    if(this.actionForm.controls.comments.get(j.toString()).value == ""){
      this.actionForm.controls.comments.get(j.toString()).setValidators([Validators.required])
      this.actionForm.controls.comments.get(j.toString()).updateValueAndValidity()
    } else {
      this.actionForm.controls.comments.get(j.toString()).clearValidators()
      this.actionForm.controls.comments.get(j.toString()).updateValueAndValidity()
    }
    // this.commentReq = (this.actionForm.get('comments').value == "") ? true : false;
    if (this.actionForm.valid) {
      this.data = {
        "urn": urn,
        "EntityID": this.entityId,
        "Remarks": this.actionForm.controls.comments.get(j.toString()).value,
        "action": 'RP'
      }
      this.es.peactionforbinding(this.data)
        .subscribe(r => {
          if (r.status == "success") {
            this.$modal.successModal({
              title: 'PE TM Binding Action',
              msg: r.message
            });
            // this.router.navigateByUrl('/petmbinding-pelist');
            this.data = {
              "EntityID": this.entityId
            }
            this.fetchpetmbindinglist(this.data)

          }
          else {
            this.$modal.errorModal({
              title: 'PE TM Binding Action',
              msg: r.message
            });
          }
        })
    }
  }


  openDropdown(value) {
    this.showStatusDropdown = false
    if (value == "Status") {
      this.showStatusDropdown = true;
    }
  }


  downloadPeTmListCSV() {
    var fileName;
    const currentdate = formatDate(now, 'medium', 'en-US', '+0530');
    this.es.exportPeTmListCSV(this.data).subscribe(r => {
      fileName = currentdate + this.entityId + '_PETMBinding_PE.csv';


      importedSaveAs(r, fileName)
      this.$modal.successModal({
        title: 'Pe List',
        msg: 'File has been downloaded Successfully'
      });
    });
  }

  resetValue() {
    this.data = {

      "Start_Date": '',
      "End_Date": '',
      "filterType": '',
      "param": '',
      "EntityID": this.db.get(Constants.SESSSION_STORAGE,Constants.ENTITY_ID),    

    }
    this.form1.searchBy1 = null
    this.fetchpetmbindinglist(this.data);
  }
}

